import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { ModelImageComponent } from './model-image.component';
import { ModelImageDetailComponent } from './model-image-detail.component';
import { ModelImagePopupComponent } from './model-image-dialog.component';
import { ModelImageDeletePopupComponent } from './model-image-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class ModelImageResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const modelImageRoute: Routes = [
  {
    path: 'model-image',
    component: ModelImageComponent,
    resolve: {
      'pagingParams': ModelImageResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.modelImage.home.title'
    }
  }, {
    path: 'model-image/:id',
    component: ModelImageDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.modelImage.home.title'
    }
  }
];

export const modelImagePopupRoute: Routes = [
  {
    path: 'model-image-new',
    component: ModelImagePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.modelImage.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'model-image/:id/edit',
    component: ModelImagePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.modelImage.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'model-image/:id/delete',
    component: ModelImageDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.modelImage.home.title'
    },
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/model-image/model-image.route.ts